import { useParams as useRouterParams } from 'react-router-dom';

export const useMapParams = () => {
  // 本家のuseParamsから値を取得
  const params = useRouterParams();

  let { mapType, location } = params;

  // ★ここに「判定ロジック」を集約します★
  // mapType が '@' で始まっていたら、それは mapType ではなく location であるとみなす
  if (mapType?.startsWith('@') ?? false) {
    location = mapType;
    mapType = undefined; // あるいは '' や null など、アプリの仕様に合わせてください
  }

  if (location != null) {
    location = location.replace(/[^0-9.,-]/g, '');
  }

  // 補正した値を返す
  return { ...params, mapType, location };
};
